import * as React from "react";
import {useCompatibleWithQuery} from "../../../../../hooks/useCompatibleWithQuery";

export const CompatibleWith = () => {
    const {model: {hasCompatibleWith, count, compatibleWith}} = useCompatibleWithQuery();

    // If there are no cross-sells, return an empty fragment
    if (!hasCompatibleWith) return <></>;

    return (
        <div className="mb-3 mb-3 ">
            <span className="fw-bold me-1">Compatible with:</span>
            {compatibleWith.map(({product: {sku, path}}, index) => (
                <CrossSell key={index}
                           href={path}
                           sku={sku}
                           punctuation={index < count - 1 ? ", " : undefined}/>
            ))}
        </div>
    )
}

const CrossSell = ({sku, href, punctuation}: { sku: string, href: string, punctuation?: string }) => (
    <>
        <a href={href}  tabIndex={0} role="link" aria-label="Link to product details.">
            {sku}
        </a>
        {punctuation && punctuation}
    </>
);